module.exports = __webpack_public_path__ + "img/big-lick-brewing-co.3accba16.jpeg";